/*
  Busca preditiva (02/10/2026). Conceito aprovado em design-preview/v4-busca/.

  O JAVASCRIPT NAO DESENHA NADA. Ele pede a secao predictive-search pela API
  nativa (routes.predictive_search_url com section_id) e insere o HTML que o
  Liquid devolve, como a gaveta do carrinho faz. O filtro, a ordem e os textos
  moram no tema, editaveis no Personalizar.

  SEM ESTE ARQUIVO NADA SOME. O campo do cabecalho e um formulario GET para
  /search, e a lupa do celular e um link para /search.

  COMPORTAMENTO (padrao combobox com listbox do WAI-ARIA APG)
    abre a partir de 2 letras, 300 ms depois da ultima tecla
    AbortController cancela o pedido anterior; resposta guardada por termo
    setas movem, Enter abre a opcao ativa (sem opcao ativa, envia o formulario)
    seta para a direita numa busca sugerida poe o texto no campo
    digitar devolve o foco visual ao campo: Enter antes da resposta nova envia
      o termo digitado, nunca a opcao marcada para o termo anterior
    Esc fecha e o segundo Esc limpa. No celular o primeiro Esc so tira a marca da
      opcao ativa, e o seguinte fecha a camada mantendo o texto (limpar e o X).
      preventDefault no Esc: o Chrome apaga input[type=search] sozinho.
    Tab sai e fecha; clique fora fecha
    regiao role=status fixa, fora da caixa, atualizada depois de cada resposta e
      esvaziada ao fechar, para a mesma frase ser anunciada de novo ao reabrir
    celular: <dialog> com showModal (foco preso pelo navegador), rolagem travada
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-ps-root]');
  if (!raiz || !window.fetch || !window.AbortController || !window.DOMParser) return;

  var MINIMO = 2;
  var ESPERA = 300;
  var url = raiz.getAttribute('data-ps-url') || '/search/suggest';
  var marcaSecao = document.querySelector('[data-ps-section]');
  var secao = marcaSecao ? marcaSecao.getAttribute('data-ps-section') : 'predictive-search';
  var statusEl = raiz.querySelector('[data-ps-live]');
  var cache = new Map();
  var controle = null;

  function chave(termo) { return termo.trim().replace(/\s+/g, ' ').toLowerCase(); }

  function pedir(termo) {
    var k = chave(termo);
    if (controle) controle.abort();
    if (cache.has(k)) return Promise.resolve(cache.get(k));
    controle = new AbortController();
    var p = new URLSearchParams();
    p.set('q', termo.trim());
    p.set('section_id', secao);
    p.set('resources[type]', 'product,collection,article,page,query');
    p.set('resources[limit]', '10');
    p.set('resources[limit_scope]', 'each');
    // `show`, e nao `last`: com `last` a Shopify cortava a Picanha esgotada da
    // busca "picanha". A ordem (esgotado depois) e decidida no Liquid.
    p.set('resources[options][unavailable_products]', 'show');
    p.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    return fetch(url + '?' + p.toString(), { signal: controle.signal, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('predictive search ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('[data-ps-result]');
        if (!res) throw new Error('predictive search: empty section');
        var saida = { html: res.outerHTML, status: res.getAttribute('data-ps-status') || '' };
        cache.set(k, saida);
        return saida;
      });
  }

  function Combo(cfg) {
    var input = cfg.input;
    var painel = cfg.painel;
    var movel = !!cfg.movel;
    var pfx = cfg.pfx;
    var relogio = null;
    var ativo = -1;
    var pedidoDe = '';

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', pfx + '-lb');

    function aberto() { return input.getAttribute('aria-expanded') === 'true'; }
    function opcoes() {
      return Array.prototype.filter.call(painel.querySelectorAll('[role="option"]'), function (o) {
        return o.getClientRects().length > 0;
      });
    }

    // Rola so a lista, nunca a pagina: scrollIntoView rolaria a pagina inteira.
    function mostrar(el) {
      var caixa = movel ? painel : painel.querySelector('.ps-scroll');
      if (!caixa || !caixa.contains(el)) return;
      var pe = 0;
      if (movel) {
        var foot = painel.querySelector('.ps-foot');
        if (foot && !foot.contains(el)) pe = foot.offsetHeight;
        if (foot && foot.contains(el)) return;
      }
      var r = el.getBoundingClientRect();
      var c = caixa.getBoundingClientRect();
      if (r.top < c.top) caixa.scrollTop -= (c.top - r.top);
      else if (r.bottom > c.bottom - pe) caixa.scrollTop += (r.bottom - (c.bottom - pe));
    }

    function marcar(i) {
      var o = opcoes();
      o.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
      ativo = i;
      if (i >= 0 && o[i]) {
        o[i].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', o[i].id);
        mostrar(o[i]);
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function exibir(saida) {
      painel.innerHTML = saida.html.replace(/__PS__/g, pfx);
      painel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      ativo = -1;
      input.removeAttribute('aria-activedescendant');
      if (cfg.form && !movel) cfg.form.classList.add('is-open');
      if (!movel) medir();
      if (cfg.status) cfg.status.textContent = saida.status;
    }

    // Altura util da caixa: o que sobra da janela abaixo dela.
    function medir() {
      var topo = painel.getBoundingClientRect().top;
      painel.style.setProperty('--ps-max', Math.max(240, window.innerHeight - topo - 16) + 'px');
    }

    function inicio() {
      if (movel && cfg.inicio) {
        painel.innerHTML = '';
        painel.appendChild(cfg.inicio.content.cloneNode(true));
        painel.hidden = false;
      } else {
        painel.hidden = true;
        painel.innerHTML = '';
      }
    }

    function abrir() {
      var v = input.value.trim();
      if (v.length < MINIMO) { fechar(); inicio(); return Promise.resolve(); }
      pedidoDe = v;
      return pedir(v).then(function (saida) {
        // Resposta atrasada de um termo que ja nao esta no campo: descarta.
        if (input.value.trim() !== pedidoDe) return;
        exibir(saida);
      }).catch(function (e) {
        if (e && e.name === 'AbortError') return;
        // Erro de rede: no celular a lista do termo anterior ficaria na tela,
        // tocavel, com outro termo no campo. inicio() volta ao estado sem busca.
        fechar();
        inicio();
      });
    }

    function fechar() {
      if (controle) controle.abort();
      clearTimeout(relogio);
      if (!movel) { painel.hidden = true; }
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      if (cfg.form) cfg.form.classList.remove('is-open');
      ativo = -1;
      if (cfg.status) cfg.status.textContent = '';
    }

    function preencher(texto) {
      input.value = texto;
      input.focus();
      try { input.setSelectionRange(texto.length, texto.length); } catch (e) { /* type=search em navegador antigo */ }
      abrir();
    }

    input.addEventListener('input', function () {
      clearTimeout(relogio);
      // A lista na tela e do termo anterior: nenhuma opcao dela fica marcada.
      marcar(-1);
      if (cfg.aoDigitar) cfg.aoDigitar();
      if (input.value.trim().length < MINIMO) { fechar(); inicio(); return; }
      relogio = setTimeout(abrir, ESPERA);
    });

    input.addEventListener('focus', function () {
      if (!aberto() && input.value.trim().length >= MINIMO) abrir();
    });

    input.addEventListener('keydown', function (e) {
      if (e.isComposing) return;
      var o = opcoes();
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!aberto()) abrir();
          else if (o.length) marcar(Math.min(ativo + 1, o.length - 1));
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (aberto()) marcar(Math.max(ativo - 1, -1));
          break;
        case 'ArrowRight':
          if (aberto() && ativo >= 0 && o[ativo] && o[ativo].hasAttribute('data-fill') && input.selectionStart === input.value.length) {
            e.preventDefault();
            preencher(o[ativo].getAttribute('data-fill'));
          }
          break;
        case 'Enter':
          if (aberto() && ativo >= 0 && o[ativo]) {
            e.preventDefault();
            window.location.href = o[ativo].href;
          }
          break;
        case 'Escape':
          e.preventDefault();
          if (movel) {
            if (ativo >= 0) marcar(-1);
            else if (cfg.aoSair) cfg.aoSair();
          } else if (aberto()) {
            fechar();
          } else if (input.value) {
            input.value = '';
          }
          break;
        case 'Tab':
          if (!movel) fechar();
          break;
      }
    });

    painel.addEventListener('click', function (e) {
      var b = e.target.closest('.ps-ins');
      if (b) { e.preventDefault(); preencher(b.getAttribute('data-fill')); }
    });

    if (cfg.dentro) {
      document.addEventListener('pointerdown', function (e) {
        if (aberto() && !cfg.dentro(e.target)) fechar();
      });
    }

    window.addEventListener('resize', function () { if (!movel && aberto()) medir(); });

    return { abrir: abrir, fechar: fechar, inicio: inicio };
  }

  // ---- desktop: a pilula do cabecalho e a caixa presa a regua ----
  var formD = raiz.querySelector('[data-ps-form="d"]');
  var painelD = document.getElementById('bbq-ps-d');
  if (formD && painelD) {
    Combo({
      input: formD.querySelector('input[name="q"]'),
      painel: painelD,
      form: formD,
      pfx: 'bbq-ps-d',
      status: statusEl,
      dentro: function (alvo) { return formD.contains(alvo) || painelD.contains(alvo); }
    });
  }

  // ---- celular: a lupa abre o <dialog> ----
  var lupa = raiz.querySelector('[data-ps-open]');
  var camada = document.getElementById('bbq-ps-layer');
  if (lupa && camada && typeof camada.showModal === 'function') {
    var formM = camada.querySelector('[data-ps-form="m"]');
    var inputM = formM.querySelector('input[name="q"]');
    var limpar = camada.querySelector('[data-ps-clear]');
    var painelM = document.getElementById('bbq-ps-m');
    var modelo = document.querySelector('template[data-ps-start]');

    lupa.setAttribute('aria-haspopup', 'dialog');
    lupa.setAttribute('aria-expanded', 'false');
    lupa.setAttribute('aria-controls', 'bbq-ps-layer');

    var acertaLimpar = function () { limpar.hidden = !inputM.value; };

    // A limpeza roda na hora, e nao so no evento `close`: o navegador entrega
    // esse evento numa tarefa propria, e com a pagina sem desenhar (aba em
    // segundo plano, medido em 02/10) ele atrasa e a rolagem ficava travada.
    var aberta = false;
    var aoFechar = function () {
      if (!aberta) return;
      aberta = false;
      comboM.fechar();
      document.documentElement.classList.remove('ps-lock');
      lupa.setAttribute('aria-expanded', 'false');
      lupa.focus({ preventScroll: true });
    };
    var fecharCamada = function () {
      if (camada.open) camada.close();
      aoFechar();
    };

    var comboM = Combo({
      input: inputM,
      painel: painelM,
      movel: true,
      pfx: 'bbq-ps-m',
      status: camada.querySelector('[data-ps-live-m]'),
      inicio: modelo,
      aoDigitar: acertaLimpar,
      aoSair: fecharCamada
    });

    lupa.addEventListener('click', function (e) {
      e.preventDefault();
      camada.showModal();
      aberta = true;
      document.documentElement.classList.add('ps-lock');
      lupa.setAttribute('aria-expanded', 'true');
      acertaLimpar();
      inputM.focus({ preventScroll: true });
      if (inputM.value.trim().length >= MINIMO) comboM.abrir();
      else comboM.inicio();
    });

    // Esc com o foco fora do campo (num link da lista, por exemplo): o navegador
    // pede para fechar, e quem fecha e limpa e o script.
    camada.addEventListener('cancel', function (e) {
      e.preventDefault();
      fecharCamada();
    });
    camada.addEventListener('close', aoFechar);

    camada.querySelector('[data-ps-close]').addEventListener('click', fecharCamada);

    limpar.addEventListener('click', function () {
      inputM.value = '';
      comboM.fechar();
      comboM.inicio();
      acertaLimpar();
      inputM.focus();
    });

    // Se a tela crescer com a camada aberta (celular virado), ela fecha: no
    // desktop a busca e a pilula do cabecalho.
    window.matchMedia('(min-width: 1001px)').addEventListener('change', function (m) {
      if (m.matches && camada.open) fecharCamada();
    });

    // Voltar com o botao do navegador traz a pagina do cache com a camada aberta.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && camada.open) fecharCamada();
    });
  }

  // ---- pagina /search: as pilulas filtram os blocos sem recarregar ----
  //
  // Sem JavaScript cada pilula e uma ancora para o bloco dela (aria-current na
  // primeira). Com ele, a pilula vira botao de alternar (role=button e
  // aria-pressed): mostra so aquele bloco, e "Everything" volta a mostrar todos.
  // Espaco aciona como num botao; a URL nao muda.
  var abas = document.querySelector('[data-search-tabs]');
  if (abas) {
    var blocos = document.querySelectorAll('[data-search-block]');
    var pilulas = abas.querySelectorAll('[data-show]');
    Array.prototype.forEach.call(pilulas, function (x) {
      x.setAttribute('role', 'button');
      x.setAttribute('aria-pressed', x.classList.contains('is-on') ? 'true' : 'false');
      x.removeAttribute('aria-current');
    });
    abas.addEventListener('click', function (e) {
      var a = e.target.closest('[data-show]');
      if (!a) return;
      e.preventDefault();
      var mostra = a.getAttribute('data-show');
      Array.prototype.forEach.call(pilulas, function (x) {
        var liga = x === a;
        x.classList.toggle('is-on', liga);
        x.setAttribute('aria-pressed', liga ? 'true' : 'false');
      });
      Array.prototype.forEach.call(blocos, function (b) {
        b.hidden = mostra !== 'all' && b.getAttribute('data-search-block') !== mostra;
      });
    });
    abas.addEventListener('keydown', function (e) {
      var a = e.target.closest('[data-show]');
      if (a && (e.key === ' ' || e.key === 'Spacebar')) { e.preventDefault(); a.click(); }
    });
  }
})();
